var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { QuestionDropdownAdornerViewModel } from "survey-creator-core";
import { ReactElementFactory, ReactSurveyElementsWrapper } from "survey-react-ui";
import { QuestionAdornerComponent } from "./Question";
import { ActionButton } from "../ActionButton";
var QuestionDropdownAdornerComponent = /** @class */ (function (_super) {
    __extends(QuestionDropdownAdornerComponent, _super);
    function QuestionDropdownAdornerComponent(props) {
        return _super.call(this, props) || this;
    }
    QuestionDropdownAdornerComponent.prototype.createQuestionViewModel = function (props) {
        return new QuestionDropdownAdornerViewModel(props.componentData, props.question, null);
    };
    Object.defineProperty(QuestionDropdownAdornerComponent.prototype, "dropdownModel", {
        get: function () {
            return this.model;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionDropdownAdornerComponent.prototype, "question", {
        get: function () {
            return this.dropdownModel.question;
        },
        enumerable: false,
        configurable: true
    });
    QuestionDropdownAdornerComponent.prototype.renderElementPlaceholder = function () {
        var _this = this;
        var textStyle = this.question.textStyle;
        return (React.createElement("div", { className: "svc-question__dropdown-choices--wrapper" },
            React.createElement("div", null,
                React.createElement("div", { className: "svc-question__dropdown-choices" }, (this.dropdownModel.getRenderedItems() || []).map(function (item, index) { return (React.createElement("div", { className: _this.dropdownModel.getChoiceCss(), key: "editable_choice_".concat(index) }, ReactSurveyElementsWrapper.wrapItemValue(_this.question.survey, ReactElementFactory.Instance.createElement(_this.dropdownModel.itemComponent, {
                    key: item.value,
                    question: _this.question,
                    cssClasses: _this.question.cssClasses,
                    isDisplayMode: true,
                    item: item,
                    textStyle: textStyle,
                    index: index,
                    isChecked: _this.question.value === item.value
                }), _this.question, item))); })),
                this.dropdownModel.needToCollapse ?
                    React.createElement(ActionButton, { click: this.dropdownModel.switchCollapse, text: this.dropdownModel.getButtonText(), allowBubble: true }) :
                    null)));
    };
    return QuestionDropdownAdornerComponent;
}(QuestionAdornerComponent));
export { QuestionDropdownAdornerComponent };
ReactElementFactory.Instance.registerElement("svc-dropdown-question", function (props) {
    return React.createElement(QuestionDropdownAdornerComponent, props);
});
